import { z } from "zod"
import type { ColumnSizing } from "@/lib/column-widths"

export const COLUMNS = [
  "number",
  "title",
  "ata",
  "type",
  "threshold",
  "interval",
  "phases",
  "zones",
  "applicability",
  "man_hours",
  "reference",
] as const

export const columnSchema = z.enum(COLUMNS)

export type Column = z.infer<typeof columnSchema>

export const DEFAULT_COLUMNS: Column[] = [...COLUMNS]

export const COLUMN_LABELS: Record<Column, string> = {
  number: "Task no.",
  title: "Description",
  ata: "ATA",
  type: "Type",
  threshold: "Threshold",
  interval: "Interval",
  phases: "Phases",
  zones: "Zones",
  applicability: "Applicability",
  man_hours: "Man-hrs",
  reference: "Reference",
}

export type Slot = Column | "actions"

export const COLUMN_SIZING: ColumnSizing<Slot> = {
  id: "programme-items",
  widths: {
    number: 11,
    title: 18,
    ata: 3.5,
    type: 4,
    threshold: 8.5,
    interval: 8.5,
    phases: 8,
    zones: 6.5,
    applicability: 10,
    man_hours: 4.5,
    reference: 7.5,
    actions: 3.25,
  },
  fill: "title",
  pinned: ["actions"],
  extras: ["actions"],
  dropOrder: [
    "reference",
    "applicability",
    "phases",
    "zones",
    "man_hours",
    "type",
    "ata",
    "threshold",
  ],
}

export function withNumber(columns: Column[]): Column[] {
  return COLUMNS.filter(
    (column) => column === "number" || columns.includes(column),
  )
}

export function slotsOf(columns: Column[]): Slot[] {
  return [...columns, "actions"]
}
